<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "relatorio-justificativa-nao-atendimento") {
            next({ name: "relatorio-justificativa-nao-atendimento-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "relatorio-justificativa-nao-atendimento") {
            this.$router.push({ name: "relatorio-justificativa-nao-atendimento-list" });
        }
    },
};
</script>